import PrinterIcon from '@/features/ui/icons/components/PrinterIcon'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'

interface NameProps {
    printerName: string | null
}

const Header: FC<NameProps> = ({ printerName }) => {
    const { t } = useTranslation()

    return (
        <View style={styles.header}>
            <PrinterIcon width="24" height="24" style={styles.icon} />
            <Typography.Heading variant="h2" numberOfLines={1} style={styles.heading}>
                {t('settings.printers.printManagement.printer')}
                {' - '}
                {printerName || t('settings.printers.printManagement.noName')}
            </Typography.Heading>
        </View>
    )
}

const styles = StyleSheet.create({
    header: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
        maxWidth: '100%',
    },
    icon: {
        flexShrink: 0,
    },
    heading: {
        flexShrink: 1,
    },
})

export default Header
